"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generate = void 0;
function generate(url, categoriesList, subCategoriesList) {
    var breadCrumb = '<div class="generated-breadcrumb"><span id="clickable-home-button"><i class="glyphicon glyphicon-home clickable" id="home-button"></i></span>';
    var pathSeparator = '<span class="breadcrumb-separator"><i class="glyphicon glyphicon-chevron-right"></i></span>';
    var addMoreButton = '<span id="clickable-add-more-button"><i class="glyphicon glyphicon-option-horizontal clickable" id="add-more-button"></span>';
    //categories parameter
    if (url.indexOf("ProductSearch/") != -1 && categoriesList.length > 0) {
        var regex = /ProductSearch\/([0-9]+)/;
        var matchResult = url.match(regex);
        if (matchResult.length < 1)
            return breadCrumb;
        var categoryId = matchResult[1];
        var categoryResult = categoriesList.filter(function (c) { return c.Id == categoryId; })[0];
        if (categoryResult == undefined)
            return breadCrumb;
        breadCrumb = breadCrumb.concat(pathSeparator, '<a id="breadcrumb-category" class="clickable" href="">', categoryResult.Name, '</a>');
    }
    //subcategories parameter
    if (url.indexOf("SubCategoryId=") != -1 && subCategoriesList.length > 0) {
        var regex = /SubCategoryId=([0-9]+)/;
        var matchResult = url.match(regex);
        if (matchResult.length < 1)
            return breadCrumb;
        var categoryId = matchResult[1];
        var subCategoryResult = findCategory(categoryId, subCategoriesList);
        if (subCategoryResult == undefined)
            return breadCrumb;
        breadCrumb = breadCrumb.concat(pathSeparator, '<span id="breadcrumb-subcategory" class="clickable">', subCategoryResult.Name, '</span>');
    }
    //add more button when there is not subcategory
    if (url.indexOf("ProductSearch/") != -1 && url.indexOf("SubCategoryId=") == -1) {
        breadCrumb = breadCrumb.concat(pathSeparator, addMoreButton);
    }
    breadCrumb = breadCrumb.concat("</div>");
    return breadCrumb;
}
exports.generate = generate;
function findCategory(id, array) {
    for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
        var node = array_1[_i];
        if (node.Id == id)
            return node;
        if (node.Children) {
            var child = findCategory(id, node.Children);
            if (child)
                return child;
        }
    }
}
